<app-autocomplete-select
  [options]="options"
  [searchFn]="search"
  [preloadFn]="preload"
  [placeholder]="placeholder"
  [selectClass]="selectClass"
  [disabled]="disabled"
  [ngModel]="value"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="valueChanged($event)"
></app-autocomplete-select>
